import { NA_COUNTRIES } from '@constants';

export function formatTimestamp(
    iso: string,
    locale: string,
    opts: { timeZone?: string } = {}
): string {
    const normalized = iso.replace(/(\.\d{3})\d+Z$/, '$1Z');
    const date = new Date(normalized);

    const has12HourFormat: boolean = NA_COUNTRIES.includes(
        locale.split('-')[1].toLowerCase()
    );

    const { timeZone } = opts;

    const formatter = new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: has12HourFormat,
        timeZone,
    });

    const parts = formatter
        .formatToParts(date)
        .reduce<Record<string, string>>((acc, p) => {
            if (p.type !== 'literal') {
                acc[p.type] = p.value;
            }
            return acc;
        }, {});

    const hour = parts.hour;
    const minute = parts.minute;
    const dayPeriod = (parts.dayPeriod || '').toLowerCase();
    const beforeAppendingDayPeriod = `${parts.weekday}, ${parts.month} ${parts.day}, ${parts.year} - ${hour}:${minute}`;

    if (!has12HourFormat) {
        return beforeAppendingDayPeriod;
    }

    return beforeAppendingDayPeriod + ` ${dayPeriod}`;
}
